import React from 'react';
import { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Button, Tooltip, TextField} from '@mui/material';
import DialogComponent from './dialogComponent';
import { Grid, Typography, Box } from '@mui/material';
import CircularProgress from '@material-ui/core/CircularProgress';

function PartnerDetails({ result }) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <Typography><strong>Partner ID:</strong> {result.partnerId}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography><strong>Name:</strong> {result.name}</Typography>
            </Grid>
        </Grid>
    );
}

function PartnerDetailsTable({ result, handleSubmit }) {
    const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [editableRow, setEditableRow] = useState(null);
    const [editableData, setEditableData] = useState({});
    const [previousData, setPreviousData] = useState({});
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [results, setResults] = useState({
        open: false,
        title: '',
        description: '',
        children: null,
    });
    const [loading, setLoading] = useState(false);

    const handleDialogClose = () => {
        setAlertOpen(false);
    };
  
    const handleButtonClick = (removeProvision, row) => {
        setSelectedRowData(row);
        setSelectedRow([row.id]); 
        console.log('Perform action on:', row);
        //console.log('Perform action on:', selectedRow);
        if (row) {
            console.log("selectedRowData.id: ", row.id);
        } else {
            console.log("selectedRowData is null or undefined");
        }
        try {         
            setLoading(true);  
            fetch(apiUrl + '/api/provision/provision', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ partnerId: row.partnerId, companyId: row.instanceIdentifier, productInstanceId: row.id, domain: row.metadata.domain, removeProvision: removeProvision }, null, 2),
            })
            .then((response) => {
                if (!response.ok) { 
                    setResults({
                        open: true,
                        title: 'Error',
                        description: <p>${response.status}</p>,
                        children: '', 
                    });
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                console.log('Provision response data:', data);
                setLoading(false);
                setResults({
                    open: true,
                    title: 'Results:',
                    description: typeof data === 'string' ? data.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    )) : JSON.stringify(data, null, 2), 
                    children: '', 
                });
            })
            .catch((error) => {
                console.error('Error in provision fetch: ', error);
                setLoading(false);
            });
        } catch (err) {
            console.log("Error calling provision", err);
        }      
    };

    const handleEditClick = (row) => {
        setPreviousData(row.metadata.installTypeId); 
        setEditableRow(row.id);
        setSelectedRow([row.id]); 
        setSelectedRowData(row); 
        setEditableData({
            ...row,
            metadata: {
                ...row.metadata,
                installTypeId: row.metadata.installTypeId || ''
            }
        });
    };

    const handleInputChange = (e, field) => {
        const [mainField, subField] = field.split('.');
        const value = e.target.value.toUpperCase().slice(0, 1); // Ensure only one uppercase character
        if (subField) {
            setEditableData({
                ...editableData,
                [mainField]: {
                    ...editableData[mainField],
                    [subField]: value,
                },
            });
        } else {
            setEditableData({
                ...editableData,
                [field]: value,
            });
        }
    };

    const handleSaveClick = (e) => {
        console.log('handleSaveClick called');
        if (e && e.preventDefault) {
            console.log('Preventing default event behavior');
            e.preventDefault();
        }

        if (!selectedRowData) {
            console.error('selectedRowData is null or undefined');
            return;
        }

        setLoading(true);
        const newValue = editableData.metadata.installTypeId;

        fetch(apiUrl + '/api/provision/update-instance-type', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ productInstanceId: selectedRowData.id, oldValue: previousData, newValue: newValue }, null, 2),
        })
        .then((response) => {
            if (!response.ok) { 
                setResults({
                    open: true,
                    title: 'Error',
                    description: <p>${response.status}</p>,
                    children: '', 
                });
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            setEditableRow(null);
            setLoading(false);
            setResults({
                open: true,
                title: 'Results:',
                description: <pre>{JSON.stringify(data, null, 2)}</pre>,
                children: '', 
            });
            setEditableData((prevData) => ({
                ...prevData,
                metadata: {
                    ...prevData.metadata,
                    installTypeId: newValue
                }
            }));
            handleSubmit();
        })
        .catch(error => {
            console.error('Error updating data:', error);
            setLoading(false);
        });
    };

    const handleUndoClick = () => {
        setEditableData(previousData); 
        setEditableRow(null); 
    };

    return (
        <>
        <Box width="100%">
            <TableContainer component={Paper} sx={{marginTop: 1, maxWidth: "100%", overflowX: 'auto'}}>
                <Table sx={{ minWidth: 650}} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Partner ID</TableCell>
                            <TableCell>Product Instance ID</TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Instance ID</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Version</TableCell>
                            <TableCell>Domain</TableCell>
                            <TableCell>Company Id</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {Array.isArray(result) && result.map((row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.partnerId}</TableCell>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>{row.product.identifier}</TableCell>
                            <TableCell>{row.instanceIdentifier}</TableCell>
                            <TableCell>{row.instanceStatus.identifier}</TableCell>
                            <TableCell>{row.version}</TableCell>
                            <TableCell>{row.metadata.domain ? row.metadata.domain : 'N/A'}</TableCell>
                            <TableCell>{row.metadata.loginCompanyName ? row.metadata.loginCompanyName : 'N/A'}</TableCell>
                            <TableCell>
                                {editableRow === row.id ? (
                                    <TextField
                                        value={editableData.metadata.installTypeId}
                                        onChange={(e) => handleInputChange(e, 'metadata.installTypeId')}
                                        inputProps={{ maxLength: 1, pattern: "[A-Z]" }}
                                    />
                                ) : (
                                    row.metadata.installTypeId ? row.metadata.installTypeId : 'N/A'
                                )}
                            </TableCell>
                            <TableCell>     
                                {editableRow === row.id ? (
                                    <form onSubmit={handleSaveClick}>
                                        <Button variant="contained" color="primary" type="submit">
                                            Save
                                        </Button>
                                        <Button variant="contained" color="secondary" onClick={handleUndoClick} sx={{ marginLeft: 1 }}>
                                            Cancel
                                        </Button>
                                    </form>
                                ) : (
                                    <>
                                    <Button variant="contained" color="secondary" onClick={() => handleEditClick(row)}>
                                        Edit
                                    </Button>
                                    {row.metadata.installTypeId && row.metadata.installTypeId === "P" && <Tooltip title="Provision Instance"><Button variant="contained" color="primary" onClick={() => handleButtonClick("false", row)} sx={{ marginLeft: 1 }}>Provision</Button></Tooltip>}
                                    {row.metadata.installTypeId && row.metadata.installTypeId === "P" && <Tooltip title="Remove Provision"><Button variant="contained" color="error" onClick={() => handleButtonClick("true", row)} sx={{marginLeft: 1}}>Remove</Button></Tooltip>}
                                    </>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
        {loading && (
            <Box 
                sx={{ 
                    position: 'fixed', 
                    top: 0, 
                    left: 0, 
                    width: '100%', 
                    height: '100vh', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    backgroundColor: 'transparent' 
                }}
            >
                <CircularProgress />
            </Box>
        )}
        <DialogComponent
            open={alertOpen}
            handleClose={handleDialogClose}
            title="Error"
            description="Please select a row (only one at a time)"
         />
        {selectedRowData && (
            <DialogComponent
                open={results.open}
                handleClose={() => setResults({ ...results, open: false })}
                title={results.title}
                description={results.description}
            >
                {results.children}
            </DialogComponent>
        )}              
        </>
    );
    
}   

export { PartnerDetailsTable, PartnerDetails };